import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as ChatRoute from "./chat";
import * as DashboardRoute from "./dashboard";
import * as CupboardRoute from "./cupboard";
import * as DayRoute from "./day";
import * as EntryRoute from "./entry";
import * as FoodsRoute from "./foods";
import * as KeysRoute from "./keys";
import * as TargetRoute from "./target";
import * as SettingsRoute from "./settings";
import * as AccountRoute from "./account";
import * as AgentsRoute from "./agents";

// The chat is the front door: tell it what you ate. The food log it writes into
// is one link away. The sign-in flow points at the dashboard and keeps doing so;
// this is only where `/` goes.
const RootRoute = () => <Redirect to={`/chat`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"NoshChat"} menu={[]} />

            <Sidebar
              menu={[
                {
                  icon: "comments",
                  label: "Chat",
                  to: `/chat`,
                },
                {
                  icon: "cutlery",
                  label: "Food log",
                  to: `/day`,
                },
                {
                  icon: "shopping-basket",
                  label: "Cupboard",
                  to: `/cupboard`,
                },
                {
                  icon: "book",
                  label: "Foods",
                  to: `/foods`,
                },
                {
                  icon: "bullseye",
                  label: "Daily target",
                  to: `/target`,
                },
                {
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "cog",
                  label: "Settings",
                  to: `/settings`,
                },
                {
                  icon: "plug",
                  label: "Agents",
                  to: `/agents`,
                },
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                },
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route path={`/account`} component={AccountRoute.Indice} />
                  <Route path={`/agents`} component={AgentsRoute.Indice} />
                  <Route path={`/chat`} component={ChatRoute.Indice} />
                  <Route path={`/cupboard`} component={CupboardRoute.Indice} />
                  <Route path={`/dashboard`} component={DashboardRoute.Indice} />
                  <Route path={`/day`} component={DayRoute.Indice} />
                  <Route path={`/entry/:entryId`} component={EntryRoute.Indice} />
                  <Route path={`/foods`} component={FoodsRoute.Indice} />
                  <Route path={`/key`} component={KeysRoute.Indice} />
                  <Route path={`/target`} component={TargetRoute.Indice} />
                  <Route path={`/settings`} component={SettingsRoute.Indice} />
                </Switch>
              </ol>

              <Switch>
                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/agents`} component={AgentsRoute.Content} />
                <Route path={`/chat`} component={ChatRoute.Content} />
                <Route path={`/cupboard`} component={CupboardRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/day`} component={DayRoute.Content} />
                <Route path={`/entry/:entryId`} component={EntryRoute.Content} />
                <Route path={`/foods`} component={FoodsRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/target`} component={TargetRoute.Content} />
                <Route path={`/settings`} component={SettingsRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
